import React from 'react'
import { ListTable } from 'gnos-tables'
import { FormattedMessage, useIntl } from 'react-intl'
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../../../components/CustomDate'

import { LOCALE_PREFIX } from '../../../../constants'

import './style.scss'

export default function PersonTrades({ id, data }) {
    const intl = useIntl()

    return (
        <div className={'representatives-person-trades-table-wrapper'}>
            <div className={'table-title'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.personTrades`} />
            </div>
            {_.isEmpty(data) && (
                <div className={'empty-data'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.noTrades`} />
                </div>
            )}
            {!_.isEmpty(data) && (
                <ListTable
                    id={`representatives-person-trades-list-table-${id}`}
                    key={`representatives-person-trades-list-table-${id}`}
                    staticData={{
                        _table: [
                            {
                                tables: [
                                    {
                                        rows: data,
                                    },
                                ],
                            },
                        ],
                    }}
                    columnsDefinition={{
                        title: {
                            Cell: () => (
                                <span>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.trade`} />
                                </span>
                            ),
                            width: 100,
                        },
                        top: {
                            columns: [
                                {
                                    accessor: 'trade',
                                    Cell: ({ value }) => (
                                        <div className={'trade-cell'} title={value}>
                                            <span>{value}</span>
                                        </div>
                                    ),
                                },
                                {
                                    accessor: 'suspension',
                                    Cell: ({ value, original }) => (
                                        <span>
                                            {value ? (
                                                <>
                                                    {intl.formatMessage({ id: `${LOCALE_PREFIX}.interrupted` })}
                                                    {original?.suspensionStartDate && (
                                                        <span style={{ paddingLeft: '4px' }}>
                                                            {'('}
                                                            <span style={{ paddingRight: '4px' }}>
                                                                {intl.formatMessage({ id: 'global.date.from' })}
                                                            </span>
                                                            <CustomDate
                                                                date={original?.suspensionStartDate?.value}
                                                                precision={original?.suspensionStartDate?.precision}
                                                            />
                                                            {')'}
                                                        </span>
                                                    )}
                                                </>
                                            ) : (
                                                intl.formatMessage({ id: `${LOCALE_PREFIX}.uninterrupted` })
                                            )}
                                        </span>
                                    ),
                                    width: 200,
                                },
                            ],
                        },
                    }}
                    texts={{
                        loading: intl.formatMessage({ id: 'global.loading' }),
                        noData: intl.formatMessage({ id: 'global.noData' }),
                        controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                        controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                        controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                        controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                        controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                        controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                    }}
                />
            )}
        </div>
    )
}
